import React from 'react';
import { Panel, CampoTexto } from '../../bodas/admin/comunes';
import SubirImagen from './SubirImagen';

export default function DatosProducto({ producto, set }) {
  return (
    <Panel className="grid gap-5 p-5 md:grid-cols-[220px_1fr]" testId="tienda-datos-producto">
      <div>
        <p className="mb-2 text-sm font-medium text-slate-700">Imagen principal</p>
        <SubirImagen url={producto.imagen_url} onCambiar={url => set('imagen_url', url)} testId="tienda-producto-imagen" alto="aspect-[4/3]" />
      </div>
      <div className="space-y-3">
        <div className="grid gap-3 sm:grid-cols-2">
          <CampoTexto label="Nombre" value={producto.nombre} onChange={v => set('nombre', v)} maxLength={80} testId="tienda-producto-nombre" />
          <CampoTexto label="Etiqueta (opcional)" ayuda="Ej. Promoción" value={producto.etiqueta} onChange={v => set('etiqueta', v)} maxLength={30} testId="tienda-producto-etiqueta" />
          <CampoTexto label="Precio (COP)" type="number" min={1} inputMode="numeric" value={producto.precio}
            onChange={v => set('precio', v.replace(/\D/g, ''))} testId="tienda-producto-precio" />
          <CampoTexto label="Nota del precio" ayuda="Ej. IVA incluido" value={producto.precio_nota} onChange={v => set('precio_nota', v)} maxLength={60} testId="tienda-producto-precio-nota" />
        </div>
        <CampoTexto label="Descripción" multiline value={producto.descripcion} onChange={v => set('descripcion', v)} maxLength={1500} testId="tienda-producto-descripcion" />
      </div>
    </Panel>
  );
}
